import { observer } from "mobx-react-lite";
import { TabGroup } from "@synthesis/shared-ui";

import { DETAIL_TABS, usePageStore } from "../service-detail-page.lib";

/** Табы карточки услуги: активная вкладка хранится в сторе страницы. */
export const ServiceDetailTabs = observer(() => {
  const store = usePageStore()!;

  return <TabGroup className="w-full min-w-0" tabs={DETAIL_TABS} activeKey={store.activeTab} onChange={(tab) => store.setActiveTab(tab)} />;
});
